export const PHOTOBOOKS_MPVID = "photobooks";
export const isPhotobooks = (mpvId: string): boolean => mpvId === PHOTOBOOKS_MPVID;
